var _style, _g, _g2, _g3, _g4, _g5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgObiLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0owl{fill:#588443;}\r\n\t.st1owl{fill:#825716;}\r\n\t.st2owl{fill:#FAC8AA;}\r\n\t.st3owl{fill:#F9C2A0;}\r\n\t.st4owl{fill:#DBDBDB;}\r\n\t.st5owl{fill:#BAB9B9;}\r\n\t.st6owl{fill:#8D5B3C;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lag_1_1_"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0owl",
    cx: 150,
    cy: 150.3,
    r: 150
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Lag_2_1_"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Lag_6"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Lag_5"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Lag_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1owl",
    d: "M67.7,184.8"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2owl",
    d: "M100.3,69c-9.1,20.3-18.1,40.6-27.2,61c-1.6,5.8-6.1,24.3,3.8,35.6c0.7,0.8,1.6,1.7,2.5,2.5 c2.3,0.6,4.5,1.2,6.8,1.8c5.9,10.9,11.9,19.2,16.3,24.9c10.6,13.6,20.2,25.6,36.5,31.3c4.9,1.7,9.1,2.4,11.8,2.8 c0-54,0-107.9,0-161.9C134,67.6,117.2,68.3,100.3,69z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3owl",
    d: "M227,129.2c-10.5-21.4-20.9-42.7-31.4-64.1c-15.2,0.6-30.5,1.2-45.7,1.8v161.9c2.4-0.1,5.8-0.4,9.9-1.5 c16.6-4.3,26.8-16.4,37.1-29.2c5.1-6.2,11.6-15.2,17.8-27.1c3.2-0.5,5.4-1.6,7.1-2.7C230.6,162.2,232.5,146.5,227,129.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st4owl",
    d: "M87.9,130.2c9.9,18.7,19.9,37.5,29.8,56.2c2.8,0,5.7,0,8.5,0c3.9-1.7,12.6-5,24.3-5.1c12,0,20.8,3.3,24.8,5.1 c2.3,0,4.5,0,6.8,0c10.4-18.5,20.7-37,31.1-55.5c2.6,18.8,5.1,37.7,7.7,56.5c-6,9.5-11.9,19-17.9,28.4c-8.7,7.7-17.3,15.3-26,23 c-17.5-0.2-34.9-0.5-52.4-0.7c-9.4-8.1-18.7-16.2-28.1-24.4c-5.8-9.4-11.6-18.7-17.5-28.1C81.9,167.2,84.9,148.7,87.9,130.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5owl",
    d: "M117.7,195.5c0.7-15,14.8-27,31.7-27.4c17.5-0.4,32.8,11.8,33.5,27.4c4-5.7,8-11.4,12-17 c-10.1-12.3-20.3-24.6-30.4-36.9c-9.3,0-18.5,0-27.8,0c-10.5,11.7-21.1,23.4-31.6,35.1C109.2,183,113.5,189.2,117.7,195.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6owl",
    d: "M259.6,238.5c-7.7-15.8-16.1-36.8-21.8-62.5c-5.4-24-6.9-45.3-6.9-62.2c-0.2-4.5-3.1-49.3-39.7-71.1 C175,33,158.9,31.8,150,31.9c-8.9-0.1-25,1.1-41.2,10.8c-36.6,21.8-39.5,66.7-39.7,71.1c0,16.8-1.5,38.1-6.9,62.2 c-5.7,25.6-14.1,46.7-21.8,62.5c22.3,0,44.6,0,66.9,0c-27.6-55.7-23.2-110.7,5.7-134.2c5.9-4.8,17.3-11.9,37-13.2 c19.7,1.2,31.1,8.3,37,13.2c28.9,23.5,33.3,78.5,5.7,134.2C215,238.5,237.3,238.5,259.6,238.5z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgObiLogo);
export default __webpack_public_path__ + "static/media/obi-logo.7cb40a20.svg";
export { ForwardRef as ReactComponent };